import styles from './Home.module.css';

function Home() {
    return (
        <section id="home" className={`${styles.home} row`}>
            <div className="col-xl-6 text-xl-start ps-xl-5 ms-xl-5 mb-xl-0 mb-5">
                <h1 className="display-sm-5 fw-bold mb-4">Focus - seu banco de horas particular</h1>
                <p><b>Que tal fazer um uso mais eficiente do seu tempo?</b> Conheça o Focus, seu banco de horas pessoal que te ajuda a manter o foco em seus objetivos.</p>
                <button className="btn bg-black rounded-pill px-4 px-sm-5"><a href="/" className="text-white text-decoration-none">Saiba Mais</a></button>
                <button className="btn bg-primary rounded-pill px-4 px-sm-5 ms-3"><a href="/" className="text-white text-decoration-none">Download</a></button>
            </div>
            <img className={`${styles.screenshot1} col-xl-6 ms-xl-5 mx-auto`} src="/img/screenshot/screenshot1.webp" alt="Smartphone com captura de tela"/>
        </section>
    )
}

export default Home;